import { render } from "./Remediations.vue?vue&type=template&id=6595e836&scoped=true&ts=true"
import script from "./Remediations.vue?vue&type=script&lang=ts"
export * from "./Remediations.vue?vue&type=script&lang=ts"

import "./Remediations.vue?vue&type=style&index=0&id=6595e836&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6595e836"]])

export default __exports__